import { AdminActionGrowProps } from './admin-action-grow-props';
import { Grow } from '@mint/ui';
import styled from 'styled-components';

export const AdminActionGrow = styled<
  React.FunctionComponent<AdminActionGrowProps>
>(Grow)`
  transform: rotate3d(0);
  transform-origin: ${props => (props.origin ? props.origin : 'top right')};
  position: absolute;
  z-index: 1000;
  white-space: nowrap;
`;
